<template>
  <div>
    <BannerOpacity delay="5000" />
    <div class="container">
      <div class="content-wrapper">
        <div class="welcome-page-container">
          <WelcomeIcons />

          <ContactForm class="contact-form-welcome-page" />

          <BrandsIcons
            :pageCustom="[
              [480, 2],
              [768, 3],
              [1024, 4]
            ]"
            :speed="3000"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WelcomeIcons from "./../categories/src/CategoriesIconsWelcome.vue";
import BrandsIcons from "./../brands/src/BrandCarousel.vue";
import { ContactForm, BannerOpacity } from "../RedbayComponents";

export default {
  name: "WelcomePage",

  components: {
    WelcomeIcons,
    BrandsIcons,
    BannerOpacity,
    ContactForm
  },

  beforeMount() {
    if (!this.$store.state.user.authorizedUser) {
      this.$router.replace({ name: "mainPage" });
    }
    if (!this.$config.get("welcomePage.enabled")) {
      this.$router.replace({ name: "searchPage" });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/template/WelcomePage.vue